"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWRewardTypeToJSON = exports.OWRewardTypeFromJSONTyped = exports.OWRewardTypeFromJSON = exports.OWRewardType = void 0;
/**
 * The type of reward, currently only supports XP.
 * @export
 * @enum {string}
 */
var OWRewardType;
(function (OWRewardType) {
    OWRewardType["XP"] = "XP";
    OWRewardType["FUEL"] = "FUEL";
    OWRewardType["NFT"] = "NFT";
})(OWRewardType = exports.OWRewardType || (exports.OWRewardType = {}));
function OWRewardTypeFromJSON(json) {
    return OWRewardTypeFromJSONTyped(json, false);
}
exports.OWRewardTypeFromJSON = OWRewardTypeFromJSON;
function OWRewardTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OWRewardTypeFromJSONTyped = OWRewardTypeFromJSONTyped;
function OWRewardTypeToJSON(value) {
    return value;
}
exports.OWRewardTypeToJSON = OWRewardTypeToJSON;
